export class ClaimsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // `skipForbiddenError` lets a caller that renders the claim catalog in a degradable surface
  // (e.g. the broker permission-ceiling panel / security-group editor, where a non-employee may be
  // 403'd on `/Claims`) opt out of the global forbidden-status page-reload interceptor so a single
  // failed catalog read degrades in-place instead of reloading the whole app.
  async getClaims({ skipForbiddenError } = {}) {
    return this.#http.get('/Claims', {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async getClaimsByRole(params) {
    return this.#http.get('/Claims/role', { params });
  }
}
